import { Component, OnInit } from '@angular/core';
import {BeeztelCodesService} from '../../services/beeztel-codes.service';
import {AuthService} from '../../../../../core/service/auth.service';
import {LocalDataSource} from 'ng2-smart-table';
import {TickCellComponent} from '../../../../../shared/components/smart-table/tick-cell/tick-cell.component';
import {FlagCellComponent} from '../../../../../shared/components/smart-table/flag-cell/flag-cell.component';
import {ModalService} from 'ngx-dynamic-modal';
import {BeeztelCodesEditComponent} from '../../modals/beeztel-codes-edit/beeztel-codes-edit.component';
import {ActionButtonsComponent} from '../../../../../shared/components/smart-table/action-buttons/action-buttons.component';

import Swal from "sweetalert2";
import {MessagingService} from '../../../../../core/service/messaging.service';
import {VnaPortalSelected} from '../../../../../core/data/messaging/VnaPortalSelected';

@Component({
  selector: 'app-beeztel-codes-list',
  templateUrl: './beeztel-codes-list.component.html',
  styleUrls: ['./beeztel-codes-list.component.scss']
})
export class BeeztelCodesListComponent implements OnInit {

    enabled: boolean = false;
    codes: LocalDataSource;
    tableSettings: Object;

    constructor(private codesHandler: BeeztelCodesService, private auth: AuthService, private modalService: ModalService, private messaging: MessagingService) {
        this.codes = new LocalDataSource();

        this.tableSettings = {
            columns: {
                pk: { title: '#' },
                code: { title: 'Code' },
                dialstatus: { title: 'Dial status'},
                portal: { title: 'Portal', type: 'custom', renderComponent: FlagCellComponent },
                status: { title: 'Status' },
                status_doi: { title: 'Status Doi'},
                campaign_name: { title: 'Campaign' },
                check_on_alert: { type: 'custom', title: 'Check on alert', renderComponent: TickCellComponent },
                description: { title: 'Description' },
                Actions: {
                    filter: false,
                    width: '12%',
                    title:'Actions ',
                    type: 'custom',
                    renderComponent: ActionButtonsComponent,
                    onComponentInitFunction:(instance: any) => {
                        instance.action.subscribe(data => {
                            (data.action ==='onDelete')
                                ? this.deleteMappingCode(data.element)
                                : this.updateMappingCode(data.element)
                            ;

                        });
                    }
                }
            },
            attr: {
                class: 'table table-bordered'
            },
            actions: {
                add: false,
                delete: false,
                edit: false
            }
        }
    }

    modalCallback(res: any): void {
        this.ngOnInit();
    }

    createNewMapping(): void {
        this.modalService.addDynamicComponent(BeeztelCodesEditComponent, { type: 'new'}, (res) => {
            this.modalCallback(res)
        });
    }

    /**
     *
     * @param {Object} code
     */
    updateMappingCode(code: Object): void {
        this.modalService.addDynamicComponent(BeeztelCodesEditComponent, { type: 'edit', 'object' : code}, (res) => {
            this.modalCallback(res)
        })
    }

    /**
     *
     * @param {Object} code
     */
    deleteMappingCode(code: Object): void {
        this.enabled = true;
        this.codesHandler.deleteExistingCode(code).subscribe(
            (result) => {
                this.codes.remove(code);
                Swal({ type: 'success', title: 'Action performed', text: 'Code deleted successfully'});
                this.enabled = false;
            }
        )
    }

    getCodes(): void {
        this.enabled = true;
        this.codesHandler.getPortalBeeztelCodes(this.auth.getPortalSelected().portal).subscribe(
            (result) => {
                this.codes.load(result);
                this.enabled = false;
            }
        )
    }

    ngOnInit() {
        this.getCodes();
        this.messaging.message.subscribe(
            (result) => {
                if(result instanceof VnaPortalSelected){
                    this.getCodes();
                }
            }
        )
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/tools/beeztel-codes/components/beeztel-codes-list/beeztel-codes-list.component.ts